module.exports = __webpack_public_path__ + "0ea7648b0f806954e2d4ce23195ef535.svg";